import getV10APIs from './v1.0';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);

  const children = [
    mergeVersionsByTitle('주문 리스트 조회', v10APIs),
    mergeVersionsByTitle('작업 등록', v10APIs),
  ].filter(Boolean);

  return { title: 'G마켓물류', children };
};

export default data;
